import { FE_LOGGED_OUT_LIGHT_GATING_052925 } from "@faire/retailer-settings/FE_LOGGED_OUT_LIGHT_GATING_052925";
import {
  useAssignSetting,
  useSetting,
} from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { IThreeVariantXP } from "@faire/web-api--source/indigofair/settings/IThreeVariantXP";
import { route as brandRoute } from "@faire/web-api--source/routes/www/brand/brandToken";
import { route as c1Route } from "@faire/web-api--source/routes/www/category/c1CategoryUrlId";
import { route as c1BrandValueRoute } from "@faire/web-api--source/routes/www/category/c1CategoryUrlId/brand-value/brandValue";
import { route as c2Route } from "@faire/web-api--source/routes/www/category/c1CategoryUrlId/subcategory/c2CategoryUrlId";
import { route as c2BrandValueRoute } from "@faire/web-api--source/routes/www/category/c1CategoryUrlId/subcategory/c2CategoryUrlId/brand-value/brandValue";
import { route as c3Route } from "@faire/web-api--source/routes/www/category/c1CategoryUrlId/subcategory/c2CategoryUrlId/c3CategoryUrlId";
import { route as c3BrandValueRoute } from "@faire/web-api--source/routes/www/category/c1CategoryUrlId/subcategory/c2CategoryUrlId/c3CategoryUrlId/brand-value/brandValue";
import { route as discoverRoute } from "@faire/web-api--source/routes/www/discover/searchTerm";
import { route as productRoute } from "@faire/web-api--source/routes/www/product/productToken";
import { route as searchRoute } from "@faire/web-api--source/routes/www/search";
import { route as suppliersC1Route } from "@faire/web-api--source/routes/www/suppliers/c1SuppliersUrlId";
import { route as suppliersC1BrandValueRoute } from "@faire/web-api--source/routes/www/suppliers/c1SuppliersUrlId/brand-value/brandValue";
import { route as suppliersC2Route } from "@faire/web-api--source/routes/www/suppliers/c1SuppliersUrlId/subcategory/c2SuppliersUrlId";
import { route as suppliersC3Route } from "@faire/web-api--source/routes/www/suppliers/c1SuppliersUrlId/subcategory/c2SuppliersUrlId/c3SuppliersUrlId";
import { RouteMatcher } from "@faire/web/common/routes/RouteMatcher";
import { useLocation } from "react-router-dom";

import { useIsFaireDirectActiveInLoggedOut } from "../hooks/FaireDirect/useIsFaireDirectActiveInLoggedOut/useIsFaireDirectActiveInLoggedOut";
import { useIsLoggedInRetailer } from "../lib/isLoggedInRetailer";

export const ELIGIBLE_FOR_LIGHT_GATING_LIST = [
  brandRoute,
  productRoute,
  searchRoute,
  discoverRoute,
  c1Route,
  c1BrandValueRoute,
  c2Route,
  c2BrandValueRoute,
  c3Route,
  c3BrandValueRoute,
  suppliersC1Route,
  suppliersC1BrandValueRoute,
  suppliersC2Route,
  suppliersC3Route,
];

export const useIsEligibleForLightGating = (): boolean => {
  const isLoggedInRetailer = useIsLoggedInRetailer();
  const matcher = new RouteMatcher(ELIGIBLE_FOR_LIGHT_GATING_LIST);
  const isFaireDirectActive = useIsFaireDirectActiveInLoggedOut();
  const location = useLocation();
  const isPageOnAllowedList =
    matcher.match(location?.pathname ?? "") !== undefined;

  return !isLoggedInRetailer && isPageOnAllowedList && !isFaireDirectActive;
};

export const useIsLoggedOutLightGateTreatment = (): boolean => {
  const setting = useSetting(FE_LOGGED_OUT_LIGHT_GATING_052925);
  return (
    setting === IThreeVariantXP.Bucket.VARIANT_2 ||
    setting === IThreeVariantXP.Bucket.VARIANT_3
  );
};

export const useIsLoggedOutLightGateTreatmentWithEligibility = (): boolean => {
  const isEligibleForLightGating = useIsEligibleForLightGating();
  const isTreatment = useIsLoggedOutLightGateTreatment();
  return isEligibleForLightGating ? isTreatment : false;
};

export const useAssignSettingLoggedOutLightGate = () =>
  useAssignSetting(FE_LOGGED_OUT_LIGHT_GATING_052925);
